import { Image } from "@/components/Image";
import clsx from "clsx";
import Link from "next/link";
import { PlaneIcon } from "ui/iconsN";

type Props = {
  speaker: {
    id: number;
    alias: string;
    firstname: string;
    lastname: string;
    imageName: string | null;
    imageRealname: string | null;
    pickupLine: string;
    branchDescription: string;
    nextDepartureCount: number;
    nextConferenceCount: number;
  };
  className?: string;
};
export const Speaker = ({ speaker, className }: Props) => {
  return (
    <Link
      href={`/conferenciers/${speaker.alias}/`}
      className={clsx(
        "text-primary bg-white w-full md:w-[calc(50%-16px)] xl:w-[calc(33.333333%-16px)] rounded-lg border border-bg-2 flex shadow-c1 cursor-pointer h-[140px] hover:scale-105 transition-transform overflow-hidden",
        className,
      )}
    >
      <div className="overflow-hidden w-28 h-full shrink-0 object-cover">
        <Image
          alt={speaker.imageRealname || ""}
          image={{
            id: speaker.id.toString(),
            name: speaker.imageName || "",
            realname: speaker.imageRealname || "",
            type: "speaker",
          }}
          height={{
            type: "ratio",
            value: 125,
          }}
          sizes="182px"
          objectFit="cover"
        />
      </div>
      <div className="flex flex-col p-3 items-start">
        <p className="font-serif text-lg/5 font-medium line-clamp-1">{`${speaker.firstname} ${speaker.lastname}`}</p>
        <p className="font-serif text-xs/[14px] italic line-clamp-1 text-tx-2">{speaker.pickupLine}</p>
        <p className="text-xs/[14px] line-clamp-3 text-tx-3 mt-2">{speaker.branchDescription}</p>
        <div className="grow" />
        <div className="flex items-center gap-1">
          {speaker.nextDepartureCount > 0 && (
            <div className="rounded-full border border-bg-2 bg-bg-1 py-1 px-2 flex items-center gap-1 h-[22px]">
              <PlaneIcon className="text-pr-1 size-[10px]" />
              <p className="text-[10px]/3">
                <span className="text-xs/3 font-bold">{speaker.nextDepartureCount}</span> voyage
                {speaker.nextDepartureCount === 1 ? "" : "s"}
              </p>
            </div>
          )}
          {speaker.nextConferenceCount > 0 && (
            <div className="rounded-full border border-bg-2 bg-bg-1 py-1 px-2 flex items-center gap-1 h-[22px]">
              <div className="w-[11.5px]">
                <Image
                  image={{
                    type: "asset",
                    name: "amis_logo_2.png",
                    realname: "amis_logo_2.png",
                  }}
                  height={{
                    type: "ratio",
                    value: 106.5217,
                  }}
                  sizes="10px"
                  objectFit="cover"
                  alt="Amis"
                />
              </div>
              <p className="text-[10px]/3">
                <span className="text-xs/3 font-bold">{speaker.nextConferenceCount}</span> conférence
                {speaker.nextConferenceCount === 1 ? "" : "s"}
              </p>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
